import * as React from 'react';
import { Input, Label, Switch, TextArea, TextField } from '@heroui/react';
import { Segment } from '@heroui-pro/react';
import type { QuestionnaireType } from './types';

const TYPE_OPTIONS: { label: string; value: QuestionnaireType }[] = [
  { label: '调查', value: 'survey' },
  { label: '评估', value: 'evaluation' },
  { label: '测验', value: 'quiz' },
  { label: '考试', value: 'exam' },
  { label: '测评', value: 'assessment' },
  { label: '投票', value: 'vote' },
];

export interface BasicInfoSectionProps {
  title: string;
  description?: string;
  type: QuestionnaireType;
  isShared?: boolean;
  disabled?: boolean;
  onTitleChange: (v: string) => void;
  onDescriptionChange: (v: string) => void;
  onTypeChange: (v: QuestionnaireType) => void;
  onIsSharedChange: (v: boolean) => void;
}

export function BasicInfoSection({
  title,
  description = '',
  type,
  isShared = false,
  disabled,
  onTitleChange,
  onDescriptionChange,
  onTypeChange,
  onIsSharedChange,
}: BasicInfoSectionProps) {
  const handleTypeSegmentChange = React.useCallback(
    (key: React.Key) => {
      const next = String(key) as QuestionnaireType;
      if (TYPE_OPTIONS.some((o) => o.value === next)) onTypeChange(next);
    },
    [onTypeChange]
  );

  return (
    <div className="space-y-6">
      <TextField className="w-full" isDisabled={disabled} isRequired>
        <Label htmlFor="questionnaire-title">
          标题<span className="text-danger ml-1">*</span>
        </Label>
        <Input
          id="questionnaire-title"
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          placeholder="请输入问卷标题"
        />
      </TextField>

      <TextField className="w-full" isDisabled={disabled}>
        <Label htmlFor="questionnaire-description">介绍</Label>
        <TextArea
          id="questionnaire-description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="输入问卷的介绍"
          rows={3}
        />
      </TextField>

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <span className="text-sm font-medium text-foreground">问卷类型</span>
        <Segment
          className="flex-wrap"
          selectedKey={type}
          onSelectionChange={handleTypeSegmentChange}
          isDisabled={disabled}
        >
          {TYPE_OPTIONS.map((o) => (
            <Segment.Item key={o.value} id={o.value}>
              <Segment.Separator />
              {o.label}
            </Segment.Item>
          ))}
        </Segment>
      </div>

      <div className="flex items-center justify-between gap-4">
        <span className="text-sm font-medium text-foreground">是否共享</span>
        <Switch isSelected={isShared} onChange={onIsSharedChange} isDisabled={disabled}>
          <Switch.Content>
            <Switch.Control>
              <Switch.Thumb />
            </Switch.Control>
          </Switch.Content>
        </Switch>
      </div>
    </div>
  );
}
